<template>
  <transition name="slide-up">
    <div v-if="show" class="pwa-install-banner">

      <!-- iOS : guide visuel -->
      <div v-if="isIos" class="pwa-install-content">
        <button class="pwa-install-close" @click="dismiss">
          <span class="mdi mdi-close"></span>
        </button>
        <div class="pwa-install-icon">
          <span class="mdi mdi-cellphone-arrow-down"></span>
        </div>
        <div class="pwa-install-title">Installer Gwassou</div>
        <div class="pwa-install-sub">Accédez à l'app directement depuis votre écran d'accueil</div>
        <div class="pwa-install-steps">
          <div class="pwa-install-step">
            <span class="pwa-step-num">1</span>
            <span>Appuyez sur</span>
            <span class="pwa-step-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 2v12m0-12L8 6m4-4l4 4M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span>dans Safari</span>
          </div>
          <div class="pwa-install-step">
            <span class="pwa-step-num">2</span>
            <span>Puis <strong>"Sur l'écran d'accueil"</strong></span>
          </div>
        </div>
        <!-- Flèche pointant vers le bas (bouton Share de Safari) -->
        <div class="pwa-install-arrow-ios">
          <span class="mdi mdi-chevron-down"></span>
        </div>
      </div>

      <!-- Android : bouton natif -->
      <div v-else class="pwa-install-content pwa-install-content--row">
        <div class="pwa-install-icon-sm">
          <img src="/logo.png" alt="Gwassou" />
        </div>
        <div class="pwa-install-text">
          <div class="pwa-install-title">Installer Gwassou</div>
          <div class="pwa-install-sub">Ajouter à l'écran d'accueil</div>
        </div>
        <button class="pwa-install-btn" @click="installAndroid">Installer</button>
        <button class="pwa-install-close-sm" @click="dismiss">
          <span class="mdi mdi-close"></span>
        </button>
      </div>

    </div>
  </transition>
</template>

<script>
const DISMISSED_KEY = 'gwassou_install_dismissed'

export default {
  name: 'PwaInstallBanner',
  data() {
    return {
      show: false,
      isIos: false,
      deferredPrompt: null,
    }
  },
  mounted() {
    // Ne pas afficher si déjà installé (mode standalone)
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return
    // Ne pas afficher si déjà refusé
    if (sessionStorage.getItem(DISMISSED_KEY)) return

    const ua = navigator.userAgent
    const isIos = /iphone|ipad|ipod/i.test(ua) && !window.MSStream
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua)

    if (isIos && isSafari) {
      this.isIos = true
      // Délai pour ne pas afficher au démarrage
      setTimeout(() => { this.show = true }, 3000)
    } else {
      // Android / Chrome : écouter l'événement natif
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        this.deferredPrompt = e
        setTimeout(() => { this.show = true }, 2000)
      })
    }
  },
  methods: {
    async installAndroid() {
      if (!this.deferredPrompt) return
      this.deferredPrompt.prompt()
      const { outcome } = await this.deferredPrompt.userChoice
      this.deferredPrompt = null
      this.show = false
      if (outcome === 'accepted') sessionStorage.setItem(DISMISSED_KEY, '1')
    },
    dismiss() {
      this.show = false
      sessionStorage.setItem(DISMISSED_KEY, '1')
    },
  },
}
</script>

<style scoped>
.pwa-install-banner {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  z-index: 200;
  padding: 0 12px 12px;
}

.pwa-install-content {
  background: var(--pwa-dark);
  border-radius: 20px;
  padding: 20px 20px 16px;
  color: white;
  position: relative;
  box-shadow: 0 -4px 32px rgba(0,0,0,0.3);
}

/* iOS layout */
.pwa-install-close {
  position: absolute; top: 12px; right: 12px;
  background: rgba(255,255,255,0.15); border: none; border-radius: 50%;
  width: 28px; height: 28px; color: white; font-size: 16px;
  display: flex; align-items: center; justify-content: center; cursor: pointer;
}
.pwa-install-icon {
  width: 52px; height: 52px; border-radius: 14px;
  background: rgba(255,255,255,0.1);
  display: flex; align-items: center; justify-content: center;
  font-size: 26px; margin-bottom: 12px;
}
.pwa-install-title { font-size: 17px; font-weight: 700; margin-bottom: 4px; }
.pwa-install-sub { font-size: 13px; opacity: 0.7; margin-bottom: 16px; }

.pwa-install-steps { display: flex; flex-direction: column; gap: 10px; }
.pwa-install-step {
  display: flex; align-items: center; gap: 8px;
  font-size: 14px; background: rgba(255,255,255,0.08);
  border-radius: 10px; padding: 10px 12px;
}
.pwa-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: var(--pwa-accent); color: white;
  font-size: 12px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.pwa-step-icon {
  display: inline-flex; align-items: center;
  background: rgba(255,255,255,0.15); border-radius: 6px;
  padding: 3px 6px; color: var(--pwa-accent);
}
.pwa-install-arrow-ios {
  text-align: center; margin-top: 10px;
  font-size: 28px; opacity: 0.5;
  animation: bounce 1.5s infinite;
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(6px); }
}

/* Android layout */
.pwa-install-content--row {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 16px;
}
.pwa-install-icon-sm {
  width: 44px; height: 44px; border-radius: 12px;
  background: white; flex-shrink: 0; overflow: hidden;
  display: flex; align-items: center; justify-content: center;
}
.pwa-install-icon-sm img { width: 32px; height: 32px; object-fit: contain; }
.pwa-install-text { flex: 1; min-width: 0; }
.pwa-install-btn {
  flex-shrink: 0; background: var(--pwa-accent); color: white;
  border: none; border-radius: 10px; padding: 8px 16px;
  font-size: 14px; font-weight: 600; cursor: pointer;
}
.pwa-install-close-sm {
  background: rgba(255,255,255,0.15); border: none; border-radius: 50%;
  width: 28px; height: 28px; color: white; font-size: 16px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; flex-shrink: 0;
}

/* Transition */
.slide-up-enter-active, .slide-up-leave-active { transition: transform 0.35s ease, opacity 0.35s ease; }
.slide-up-enter, .slide-up-leave-to { transform: translateY(100%); opacity: 0; }
</style>
